'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _MapMapbox = require('./MapMapbox');

var _MapMapbox2 = _interopRequireDefault(_MapMapbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@vg/map-mapbox')(_MapMapbox2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/map-mapbox/lib/cjs/index.js
 ** module id = 733
 ** module chunks = 1
 **/